/** WASL branding — logo matches LoginPage / index.html og:image (Cloudinary asset, served locally). */
export const WASL_APP_NAME = "WASL";

export const WASL_DEFAULT_BACKEND_URL = "https://eemad-cc-dev.blufield.net/";

export const WASL_LOGO_PATH = "/wasl-logo.png";

export const WASL_LOGO = `${process.env.PUBLIC_URL || ""}${WASL_LOGO_PATH}`;
